import React, { ChangeEventHandler, ReactNode } from 'react'
import styles from './styles/checkbox-input.module.scss'
import classNames from 'classnames'

interface Props {
  label?: string
  isChecked: boolean
  isDisabled?: boolean
  className?: string
  onChange: ChangeEventHandler<HTMLInputElement>
  children?: ReactNode
}

const CheckboxWTN: React.FC<Props> = ({
  onChange,
  label,
  isChecked,
  children,
  isDisabled = false,
  className = '',
}) => {
  return (
    <label className={classNames(styles.checkboxWtnContainer, className)}>
      <span
        className={classNames(styles.checkboxWtn, {
          [styles.checked]: isChecked,
          [styles.disabled]: isDisabled,
        })}
      ></span>
      <input type='checkbox' disabled={isDisabled} checked={isChecked} onChange={onChange} />

      {label}

      {children}
    </label>
  )
}

export default CheckboxWTN
